/**
 * author: Soumya Shreyas
 */
import moment from "moment";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { Button, Dropdown, Form, Table } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { withTranslation } from "react-i18next";
import {
  BiDotsHorizontalRounded, BiSearch,
  BiSort,
  BiPlus
} from "react-icons/bi";
import { FcFinePrint } from "react-icons/fc";

import { Link, useNavigate } from "react-router-dom";
import Pagination from "../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  LIST_DEF_SORT,
  SORT_ORDER_DESC
} from "../../../core/constants/common";
import UserService from "../../../core/service/UserService";
import Utils from '../../../core/utilities/Utils';
import nodataimg from "../../../images/nodatafound.png";
import { Modal } from "react-bootstrap";
import UserForm from "./UserForm";
import { useLocation } from "react-router-dom";

function PagesAndSessionUserList({ t }) {
  const navigate = useNavigate();

  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [searchKey, setSearchKey] = useState("");
  const [users, setUsers] = useState([]);
  const [show, setShow] = useState(false)
  const [showIndex, setShowIndex] = useState(0)

  const listUsers = useCallback((
    pageNumber,
    itemsPerPageVal,
    searchKeyWord,
    sortFieldName
  ) => {
    UserService.getUserList({ status: 'all' }).then((response) => {
      setUsers([...response.data]);
    }).catch((error) => {
    });
  }, []);

  useEffect(() => {
    listUsers(0, itemsPerPage, searchKey, sortField);
  }, [listUsers]);




  const getRolesToDisplay = (roles) => {
    let text = '';
    roles?.forEach((role, index) => {
      text += Utils.getUserRoleText(role);
      if (index !== roles.length - 1) {
        text += ' ,';
      }
    });
    return text;
  };

  const handleClose = () => { setShow(false) };
  const handleUserClick = () => { setShow(true) };

  const renderModal = () => (
    !!users && users.length > 0 && <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title as="h5">Analytics User Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>User : {users[showIndex].name}</h5>
        <Table striped bordered hover>
          {!!users[showIndex].analyticsData && users[showIndex].analyticsData.map((session, index) => (
            <tr key={index}>
              <thead>
                <tr>
                  <th colSpan="4">
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 5px' }}>
                      <div>
                        <p style={{ margin: '0px' }}>Session Start : </p>
                        <p style={{ margin: '0px' }}>{moment(session.session_start_time).format('DD-MM-YYYY hh:mm:ss A')}</p>
                      </div>
                      <div>
                        <p style={{ margin: '0px' }}>Session End :  </p>
                        <p style={{ margin: '0px' }}>{moment(session.session_end_time).format('DD-MM-YYYY hh:mm:ss A')}</p>
                      </div>
                    </div>
                  </th>
                </tr>
                <tr key={index}>
                  <td>Path</td>
                  <td>Visited At Start</td>
                  <td>Visited At End</td>
                </tr>
              </thead>
              <tbody>
                {session.session_data.map((sessionData, i) => (
                  <tr key={i}>
                    <td style={{ minWidth: '219px' }}>{sessionData.path}</td>
                    <td>{moment(sessionData.visitedAtStart).format('DD-MM-YYYY hh:mm:ss A')}</td>
                    <td>{moment(sessionData.visitedAtEnd).format('DD-MM-YYYY hh:mm:ss A')}</td>
                  </tr>
                ))}
              </tbody>
            </tr>
          ))}
        </Table>
      </Modal.Body>

    </Modal>
  );

  return (
    <>
      <div className="FormsList">
        <div className="List_header">
          <h5 className="MH">
            {"Pages/Sessions"}
          </h5>
        </div>

        <div className="List_Table_01">
          <div className="List_table-card01_head">
            <div className="List_table-card_Search_01">
              <div className="List_table-card_Search_Box">
                {/* <Form>
                  <input
                    type="text"
                    className="form-control"
                    value={searchKey}
                    onChange={handleSearch}
                    placeholder="Search by Users"
                  />
                  <Link to="#" className="Search_iocnBox">
                    <BiSearch />
                  </Link>
                </Form> */}
              </div>
            </div>

          </div>
          <div className="card List_table-card01">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th className="th_check">
                    <Form.Check
                      inline
                      name="group1"
                      type="checkbox"
                      id="inline-checkbox-1"
                    />
                  </th>
                  <th>
                    <Link to="#">
                      {t("Name.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>{t("Email.label")}</th>
                  <th>User Status</th>
                  <th>Last Active</th>
                </tr>
              </thead>
              <tbody>
                {users?.length > 0
                  ?
                  (
                    users?.map((user, index) => (
                      <tr key={user.id} onClick={() => {
                        handleUserClick()
                        setShowIndex(index)
                      }} style={{ cursor: 'pointer' }} >
                        <td className="checkbox">
                          {" "}
                          <Form.Check
                            inline
                            name="group1"
                            type="checkbox"
                            id="inline-checkbox-1" />
                        </td>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>{user.online_status ? 'Online' : 'Offline'}</td>
                        <td>{!!user.last_active && user.last_active != 'undefined' ? moment(user.last_active).format('DD-MM-YYYY hh:mm:ss A') : ""}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <div className="Nodatafound_box">
                          <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                        </div>
                      </td>
                    </tr>
                  )}
              </tbody>
            </Table>
            {renderModal()}
          </div>
        </div>
      </div>
    </>
  );
}
PagesAndSessionUserList.propTypes = {};

export default withTranslation()(PagesAndSessionUserList);